export default __webpack_public_path__ + "static/media/olympBodyFit.35bc18a9.jpg";